import styled from '@emotion/styled';

// eslint-disable-next-line import/prefer-default-export
export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  min-height: ${({ theme }) => theme.vars.tickPointMinHeight};
  height: 100%;
  padding: ${({ theme }) => theme.spacings[1]} 0;
`;

export const IconWrapper = styled.div`
  width: 10%;
`;

export const Body = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
`;
